<template>
    <div
        class="d-inline-flex align-items-center flex-nowrap ps-1"
        v-if="(value ?? '') !== ''"
    >
        <InputBool
            v-model="internalValue.UseExternalRace"
            class="me-2"
            v-if="showCheckbox"
        />
        {{ value }}
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import type { RaceContestantDetailsExternalData } from '@/objects/RaceContestantDetailsExternalData';
import InputBool from '../Basic/InputBool.vue';

const props = defineProps<{
    /**
     * This is the race name from the source
     */
    value: string | null;

    /**
     * The full row object
     */
    row: RaceContestantDetailsExternalData;
}>();

// We only show the checkbox if the race values are different
const showCheckbox = computed(() => {
    return props.row.RaceContestantDetails.RaceName != props.row.RegisteredRaceName;
});

const internalValue = ref<RaceContestantDetailsExternalData>(props.row);
</script>
